.wrapper {
  padding: 0 40px 24px;

  @media (--reefer-media-tablet-max) {
    padding: 0 24px 16px;
  }
}

.cardGrid {
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(3, minmax(0, 1fr));

  @media (--reefer-media-tablet-max) {
    grid-template-columns: minmax(0, 354px);
    justify-content: center;
  }
}
